import { sortBy } from 'lodash';
import i18next from 'i18next';

import { CONSUMPTION_FREQUENCY } from '@admin/commons/constants/nonSalesConsumption';
import utilsXLS from '@commons/utils/makeXLS';

const createMainSheet = (storeConfig, storeName, hasCentralKitchens, currency) => {
  const hasGroups = storeConfig.some(({ groups }) => groups && groups.length);

  const columns = [
    {
      propertyKey: 'name',
      name: storeName,
    },
    {
      propertyKey: 'bufferStock',
      name: i18next.t('GENERAL.BUFFER_STOCK'),
    },
  ];

  if (hasCentralKitchens) {
    columns.splice(1, 0, {
      propertyKey: 'isKitchen',
      name: i18next.t('GENERAL.STORE_TYPE'),
      transform: (isKitchen) =>
        isKitchen ? i18next.t('GENERAL.CENTRAL') : i18next.t('GENERAL.SALE_POINT'),
    });
  }

  if (hasGroups) {
    columns.splice(hasCentralKitchens ? 2 : 1, 0, {
      propertyKey: 'groups',
      name: i18next.t('GENERAL.GROUPS'),
      transform: (groups) => groups.map(({ name }) => name).join(', '),
    });
  }

  columns.push(
    {
      propertyKey: 'consumptionFrequency',
      name: i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_COLUMN_TITLE'),
      transform: (consumptionFrequency) => {
        if (!consumptionFrequency) {
          return '';
        }

        const isDailyConsumption = consumptionFrequency === CONSUMPTION_FREQUENCY.DAILY;

        return isDailyConsumption
          ? i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_DAILY')
          : i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_PER_1000_CURRENCY', {
              currency,
            });
      },
    },
    {
      propertyKey: 'consumptionQuantity',
      name: i18next.t('ADMIN.STORES.CONSUMPTION_QUANTITY_COLUMN_TITLE'),
    },
  );

  const sortedBufferStocks = sortBy(storeConfig, 'ingredientName');

  return utilsXLS.generateDefaultSheet(
    i18next.t('GENERAL.BUFFER_STOCK'),
    columns,
    sortedBufferStocks,
  );
};

export const exportStoreConfigXLS = (storeConfig, storeName, hasCentralKitchens, currency) => {
  const filename = i18next.t('ADMIN.STORES.EXPORT_ASSOCIATED_INGREDIENTS_LIST_FILENAME');

  const mainSheet = createMainSheet(storeConfig, storeName, hasCentralKitchens, currency);

  utilsXLS.makeXLS(filename, [mainSheet]);
};
